import { ITableContainerProps } from '../table.interfaces';
import { useMemo } from 'react';
import Table from '../Table';
import { useTableData } from '../Hooks/useTableData';

const TableContainer = (props: ITableContainerProps) => {
    const { structure, callbacks } = props;
    const { filters = [], toggles } = structure;
    // const { onCellAction, onRowClick } = callbacks || {};
    const { tableState, rowsData } = useTableData(structure?.id, filters, toggles);

    const structureWithoutHiddenColumns = useMemo(() => {
        return {
            ...structure,
            cells: structure.cells.filter((cell) => !cell.hidden),
        };
    }, [structure]);

    const tableCallbacks = {
        ...callbacks,
    };

    return (
        <Table
            callbacks={tableCallbacks}
            rowsData={rowsData}
            structure={structureWithoutHiddenColumns}
            tableState={tableState}
        />
    );
};
export default TableContainer;
